export const leistung = {
    LineDiagrammMonatsleistungClass: {
        url: "Diagramm/Line",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_LineDiagrammMonatsLeistung_leistungReducer'
    }
};